import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { SharedDataService } from '../service/shared-data.service';

@Pipe({
  name: 'error',
})
export class ErrorPipe implements PipeTransform {
  errorMessage!: string;

  constructor(private translate: TranslateService, private _data: SharedDataService) {}

  transform(params: any, ...args: any[]): string {
    if (
      params['error_code'] &&
      this.translate.instant(`ERROR_CODES.${params['error_code']}`.replace(/ /g, '_').toUpperCase()) !==
        `ERROR_CODES.${params['error_code']}`.replace(/ /g, '_').toUpperCase()
    ) {
      this.errorMessage = this.translate.instant(`ERROR_CODES.${params['error_code']}`.replace(/ /g, '_').toUpperCase());
    } else if (
      params['error_hint'] &&
      this.translate.instant(`ERROR_HINTS.${params['error_hint']}`.replace(/ /g, '_').toUpperCase()) !==
        `ERROR_HINTS.${params['error_hint']}`.replace(/ /g, '_').toUpperCase()
    ) {
      this.errorMessage = this.translate.instant(`ERROR_HINTS.${params['error_hint']}`.replace(/ /g, '_').toUpperCase());
    } else if (params['error_description']) {
      this.errorMessage = params['error_description'];
    } else {
      if(args[0] || params['error_code']||params['error_hint']){
        this.errorMessage = this.translate.instant(`ERROR_CODES.RETRY`);
      }
    }
    return this.errorMessage;
  }
}
